<button pButton type="button" class="atlas-btn atlas-btn-primary tall" type="button" (click)="addPhone()"
  title="{{ 'common.add' | translate | titlecase }}">
  {{ 'common.add' | translate | titlecase }}
</button>
<div *ngFor="let phone of value; index as i">
  <div class="grid cols-1fr-5fr-collapse items-start gap-10px" *ngIf="phone.PhoneType != 'Default'">
    <div class="flex column">
      <div>{{ 'common.type' | translate | titlecase }}</div>
      <select [(ngModel)]="phone.PhoneType" class="form-control" required>
        <option>{{ 'common.select' | translate | titlecase }}</option>
        <option *ngFor="let pType of phoneTypes" [value]="pType.PhoneType">{{ pType.PhoneType }}</option>
      </select>
    </div>
    <div class="flex column">
      <div>{{ 'common.personal-information.phone-number' | translate | titlecase }}</div>
      <input type="tel" class="form-control" [(ngModel)]="phone.Phone" />
    </div>
    <div class="flex row-collapse items-end w-100">
      <button pButton type="button" class="atlas-btn atlas-btn-danger tall" type="button" (click)="deletePhone(i)"
        title="{{ 'common.delete' | translate | titlecase }}">
        {{ 'common.delete' | translate | titlecase }}
      </button>
    </div>
  </div>
</div>
